// 친구랑 같이하기 has no scripted campaign opponent (no 린/브람/세라...), so it
// borrows its visual dressing from the ending sequence's generic asset pool
// instead: one of the 3 ending backgrounds + one of the 3 villager portraits,
// picked once by the host and shared to the guest (see net.ts's `start`
// message) so both sides see the same match.

import {
  ENDING_REALM_BG,
  ENDING_FOREST_BG,
  ENDING_VILLAGE_BG,
  ENDING_VILLAGER_WOMAN,
  ENDING_VILLAGER_ELDER,
  ENDING_VILLAGER_CHILD,
} from "../campaign/ending.ts";

export const FRIEND_BACKGROUNDS = [
  ENDING_REALM_BG,
  ENDING_FOREST_BG,
  ENDING_VILLAGE_BG,
] as const;

export const FRIEND_PORTRAITS = [
  ENDING_VILLAGER_WOMAN,
  ENDING_VILLAGER_ELDER,
  ENDING_VILLAGER_CHILD,
] as const;

export interface FriendCosmetic {
  bgIdx: number;
  portraitIdx: number;
}

export function randomCosmetic(): FriendCosmetic {
  return {
    bgIdx: Math.floor(Math.random() * FRIEND_BACKGROUNDS.length),
    portraitIdx: Math.floor(Math.random() * FRIEND_PORTRAITS.length),
  };
}

export function backgroundFor(cosmetic: FriendCosmetic): string {
  return FRIEND_BACKGROUNDS[cosmetic.bgIdx] ?? FRIEND_BACKGROUNDS[0];
}

export function portraitFor(cosmetic: FriendCosmetic): string {
  return FRIEND_PORTRAITS[cosmetic.portraitIdx] ?? FRIEND_PORTRAITS[0];
}
